export default __webpack_public_path__ + "static/media/token_dist_1.83e63459.png";